import { render, staticRenderFns } from "./PayBridgeDepositPanel.vue?vue&type=template&id=2032f728&scoped=true&"
import script from "./PayBridgeDepositPanel.vue?vue&type=script&lang=js&"
export * from "./PayBridgeDepositPanel.vue?vue&type=script&lang=js&"
import style0 from "./PayBridgeDepositPanel.vue?vue&type=style&index=0&id=2032f728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2032f728",
  null
  
)

export default component.exports